import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompContext } from '@/context/__project__/CompContext'
import { useAppBuilderContext } from '@/context/AppBuilderContext'

import { CompVerticalMenuWrapperCore } from '../core/vertical-menu/wrapper'
import { CompVerticalMenu } from './CompVerticalMenu'

function CompVerticalMenuWrapper() {
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const infosProps = { ...compContext, activeLayer }

  const { menus } = useAppBuilderContext()

  // actions
  const actionContext = useBuilderActionContextV2()

  return (
    <CompVerticalMenuWrapperCore menus={menus} infos={infosProps} action={actionContext}>
      {(props) => <CompVerticalMenu {...props} />}
    </CompVerticalMenuWrapperCore>
  )
}

export default CompVerticalMenuWrapper
